import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect } from 'react';
import { ToastContainer as BaseToastContainer, Slide, toast } from 'react-toastify';
import classNameBind from 'classnames/bind';

import styles from './Toast.module.css';
import { TranslationContext } from './TranslationContext';

const bindClasses = classNameBind.bind(styles);

const ToastContainer = ({
  t,
}) => {
  useEffect(() => {
    toast.onChange((payload) => {
      if (payload.status === 'removed' && typeof payload.data.onClose === 'function') {
        payload.data.onClose();
      }
    });
  });

  return (
    <TranslationContext.Provider value={t}>
      <BaseToastContainer
        position="top-center"
        hideProgressBar
        pauseOnFocusLoss={false}
        draggable={false}
        transition={props => <Slide {...props} preventExitTransition />}
        icon={false}
        closeButton={false}
        autoClose={false}
        closeOnClick={false}
        className={bindClasses('toast-container')}
      />
    </TranslationContext.Provider>
  );
};

export { ToastContainer };
